import { DiffusionScreen } from "./diffusion-screen";

/** Screen 020 — "Diffuser vers prestataires". */
export function DiffusionPresta() {
  return <DiffusionScreen title="Diffuser vers prestataires" target="presta" />;
}
